import React from 'react';

export const ActeurIcon = (props: any) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
            <path d="M9.53,12.17c-.39-.7-1-4.52-.29-5.69a3.11,3.11,0,0,1,3-1.75,3.23,3.23,0,0,1,3,2.2,9.39,9.39,0,0,1-.94,5.4c2,.5,2.4-2.61,2.31-4.21a5.16,5.16,0,0,0-.34-2.57c-.51-1.48-1.24-3.22-3.2-3.5-1-.13-2.1,0-2.35.76-1.41-.26-2.66,1.87-3,3.28a13.18,13.18,0,0,0,0,4.89C8,11.88,8.36,12.29,9.53,12.17Z"/>
            <path d="M5.8,14.5l3.9,7.29a11.25,11.25,0,0,0,1.14.16l-4-7.7C6.45,14.33,6.1,14.42,5.8,14.5Z"/>
            <path d="M3.47,15.58a4.62,4.62,0,0,0-.39,3.13,12.31,12.31,0,0,0,5.24,2.9L4.85,14.8A2.88,2.88,0,0,0,3.47,15.58Z"/>
            <path d="M20,14.78c-.66-.53-3.32-.88-4.21-.91-.33,1.29-2.46,1.69-3.26,1.75l-.4,3.22s-.74-2.93-.74-3.22a3.37,3.37,0,0,1-2.58-1.81l-1,.2L12,22a13.48,13.48,0,0,0,9-3.3C21,17.11,20.91,15.51,20,14.78Zm-6.67,3.67a.34.34,0,1,1,.34-.34A.34.34,0,0,1,13.35,18.45Zm0-1.45a.34.34,0,0,1-.34-.33.34.34,0,0,1,.68,0A.34.34,0,0,1,13.35,17Z"/>
        </svg>
    )
}

